import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {A0} from '../../shared/entities/A0.entity';
import {AsyncPipe, DatePipe} from '@angular/common';
import {TitleDialogComponent} from '../plan/title/title.dialog.component';
import {MapperService} from '../../services/mapper.service';
import {MatDialog} from '@angular/material/dialog';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {RouterLink} from '@angular/router';
import {RiskIconComponent} from '../../shared/risk-icon.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RiskNamePipe} from '../../shared/pipe/riskName.pipe';

@Component({
  selector: 'a0-list',
  template: `
    @for (plan of groupedPlans; track plan.name_zone) {
      <div class="zone">
        <div class="zone-header zone-header-opened">
          <div>
            <span class="zone-header-name">{{ plan.name_zone }}</span>
            <span class="pm-tag">{{ plan.list.length }}</span>
          </div>
        </div>

        <div class="zone-group">
          <div class="zone-content flex-wrap flex gap-3 mt-3">
            @for (plan of plan.list; track plan.id) {
              <div class="zone-content-plan">
                <div>
                  <div class="zone-content-plan-city">
                    <div>
                      {{ plan.updated_at | date : 'd/MM/yy hh:mm' }}
                    </div>
                    <div class="bg-primary text-white rounded rounded-pill px-2 py-1 d-inline-block my-1"
                         [matTooltip]="'Utilisateur : ' + (plan.author_login ?? 'Inconnu')" [matTooltipDisabled]="isAdmin(plan.author)">
                      {{ getTypeUser(plan.author) }}
                    </div>
                    <div class="text-sm">{{ plan?.id_user ? "Plan lié à l'utilisateur " + plan?.name_user : 'Plan lié au territoire' }}
                    </div>
                  </div>
                  <div class="zone-content-plan-title">{{ plan.title }}</div>
                </div>
                <div class="mt-3 d-flex align-items-center justify-content-between">
                  <button routerLink="/plan/{{plan.id}}" class="pm-btn">Editer</button>

                  <div [matTooltip]="plan.type_risque | riskName | async " matTooltipPosition="above" class="ms-2">
                    <risk-icon [riskType]="plan.type_risque"></risk-icon>
                  </div>
                </div>

                <button class="zone-content-plan-actions" [matMenuTriggerFor]="menu">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="deletePlan(plan)">
                    <i class="bi bi-trash text-danger me-2"></i> Supprimer
                  </button>
                  <button mat-menu-item (click)="renamePlan(plan)">
                    <i class="bi bi-pen me-2"></i> Renommer
                  </button>
                  <button mat-menu-item (click)="duplicatePlan(plan)">
                    <i class="bi bi-file-earmark-plus me-2"></i> Dupliquer
                  </button>
                </mat-menu>
              </div>
            }
          </div>

        </div>
      </div>
    }
  `,
  imports: [
    DatePipe,
    MatMenu,
    MatMenuItem,
    RouterLink,
    MatMenuTrigger,
    RiskIconComponent,
    MatTooltipModule,
    RiskNamePipe,
    AsyncPipe,
  ],
  styleUrls: ['./dashboard.component.scss']
})
export class A0ListComponent implements OnChanges {

  @Input() plans: A0[] = [];
  @Output() updateListing: EventEmitter<any> = new EventEmitter<any>();

  groupedPlans: {name_zone: string; list: A0[]}[] = [];

  constructor(
    public mapperService: MapperService,
    public dialog: MatDialog,
  ) {
  }

  ngOnChanges(): void {
    this.groupPlansByZone();
  }

  groupPlansByZone(): void {
    const grouping = {};
    this.plans.forEach(plan => {
      const zone = plan.name_zone || 'Non défini';
      if (!grouping[zone]) {
        grouping[zone] = [];
      }
      grouping[zone].push(plan);
    });

    this.groupedPlans = Object.keys(grouping).map(zoneName => ({
      name_zone: zoneName,
      list: grouping[zoneName].sort(this.mostRecentPlanFirst)
    })).sort((a, b) => a.name_zone.localeCompare(b.name_zone));
  }

  deletePlan(a0: A0): void {
    const shouldDelete = confirm('Voulez-vous vraiment supprimer ce plan ?');

    if (shouldDelete) {
      this.mapperService.deletePlan(a0.id).subscribe((res) => {
        this.updateListing.next();
      });
    }
  }

  renamePlan(a0: A0): void {
    this.dialog.open(TitleDialogComponent, {
      data: {
        plan: a0
      }
    }).afterClosed().subscribe((update) => {
      if (update) {
        this.updateListing.next();
      }
    });
  }

  duplicatePlan(a0: A0): void {
    this.mapperService.duplicatePlan(a0).subscribe((res) => {
      this.updateListing.next();
    });
  }

  getTypeUser(author: string): string {
    if (author.includes('ROOT')) {
      return 'Predict';
    } else if (author.includes('ADMIN')) {
      return 'Predict';
    } else if (author.includes('PARTENAIRE')) {
      return 'Partenaire';
    }

    return 'Client';
  }

  isAdmin(author): boolean {
    return author.includes('ADMIN') || author.includes('ROOT');
  }

  mostRecentPlanFirst(a: A0, b: A0): number {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  }
}
